module.exports = __webpack_public_path__ + "img/lv8.7ce79237.png";